import type { ForgetPasswordOTPRequest } from '@/types';

import React from 'react';

import { GoBackButton } from '@/app/auth/sign-up/_components';
import { Box, Button, PinInput, Stack, Text, VStack } from '@/components';
import {
  useForgetPasswordVerifyOtp,
  useSetUpOtp,
  useTranslation,
} from '@/hooks';
import { isValidOtp } from '@/utils';

type CodeFormProps = ForgetPasswordOTPRequest & {
  goNext: ({ token }: { token: string }) => void;
};

const CodeForm: React.FC<CodeFormProps> = ({
  mobile,
  country_code_prefix,
  goNext,
}) => {
  const { t } = useTranslation('pages.forgetPassword.form.codeForm');
  const [value, setValue] = React.useState('');

  const { mutateAsync: verifyOtp, isPending: verifyLoading } =
    useForgetPasswordVerifyOtp();

  const onSubmit = (valuePinInput: string, number: number) => {
    if (isValidOtp({ value: valuePinInput, number })) {
      void verifyOtp({
        code: parseInt(valuePinInput),
        mobile,
        country_code_prefix,
      }).then(({ token }) => {
        goNext({ token });
      });
    }
    return null;
  };
  const MemoizedOnOtpReceived = React.useCallback((otpValue: string) => {
    setValue(otpValue);
    void onSubmit(otpValue, 6);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useSetUpOtp(MemoizedOnOtpReceived);
  return (
    <Stack
      w="100%"
      h="100%"
      align="flex-start"
      gap={4}
      pt={4}
      display="flex"
      flexDir="column"
      flex={1}
      as="form"
    >
      <Box gap={4} w="full" display="flex" flexDirection="column">
        <Text
          textAlign="center"
          color="gray.430"
          fontSize={{ base: 'md', lg: 'lg' }}
          mb="5px"
        >
          {t('code')}
        </Text>
        <VStack>
          <PinInput
            numberOfPinInputField={6}
            setValuePinInput={setValue}
            onComplete={onSubmit}
            value={value}
          />
        </VStack>
      </Box>
      <Stack w="full" align="center" gap={6} justify="end" flexGrow={1}>
        <Button
          type="submit"
          w="full"
          onClick={() => onSubmit(value, 6)}
          isLoading={verifyLoading}
        >
          {t('confirmCode')}
        </Button>
        <GoBackButton />
      </Stack>
    </Stack>
  );
};

export default CodeForm;
